import { IKnmDocument } from 'APIPackage/KnmModule/interfaces/IKnmDocument';
import { convertKnmDocumentAttachmentFormValueToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentFormValueToKnmData';
import { IKnmFormAttachment } from 'KnmPackage/MainModule/interfaces/IKnmFormAttachment';

export const convertKnmDocumentAttachmentsFormValuesToKnmData = (
  formAttachments: (IKnmFormAttachment | undefined)[] | undefined,
): IKnmDocument['attachments'] => {
  return (
    formAttachments?.reduce((filteredAttachments: IKnmDocument['attachments'], formAttachment) => {
      let newFilteredAttachments = filteredAttachments ? [...filteredAttachments] : null;
      const attachment = formAttachment && convertKnmDocumentAttachmentFormValueToKnmData(formAttachment);

      if (attachment) {
        if (!newFilteredAttachments) {
          newFilteredAttachments = [];
        }
        newFilteredAttachments.push(attachment);
      }

      return newFilteredAttachments;
    }, null) || null
  );
};
